(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
      result.android = t
    } else if (!result.windowsphone && !result.msedge && iosdevice) {
      result[iosdevice] = t
      result.ios = t
    } else if (mac) {
      result.mac = t
    } else if (xbox) {
      result.xbox = t
    } else if (windows) {
      result.windows = t
    } else if (linux) {
      result.linux = t
    }

    // OS version extraction
    var osVersion = '';
    if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});

},{}],2:[function(require,module,exports){
/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.inView=e():t.inView=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}var i=n(2),o=r(i);t.exports=o["default"]},function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(9),o=r(i),u=n(3),f=r(u),s=n(4),c=function(){if("undefined"!=typeof window){var t=100,e=["scroll","resize","load"],n={history:[]},r={offset:{},threshold:0,test:s.inViewport},i=(0,o["default"])(function(){n.history.forEach(function(t){n[t].check()})},t);e.forEach(function(t){return addEventListener(t,i)}),window.MutationObserver&&addEventListener("DOMContentLoaded",function(){new MutationObserver(i).observe(document.body,{attributes:!0,childList:!0,subtree:!0})});var u=function(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return n.history.indexOf(t)>-1?n[t].elements=e:(n[t]=(0,f["default"])(e,r),n.history.push(t)),n[t]}};return u.offset=function(t){if(void 0===t)return r.offset;var e=function(t){return"number"==typeof t};return["top","right","bottom","left"].forEach(e(t)?function(e){return r.offset[e]=t}:function(n){return e(t[n])?r.offset[n]=t[n]:null}),r.offset},u.threshold=function(t){return"number"==typeof t&&t>=0&&t<=1?r.threshold=t:r.threshold},u.test=function(t){return"function"==typeof t?r.test=t:r.test},u.is=function(t){return r.test(t,r)},u.offset(0),u}};e["default"]=c()},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,r){n(this,t),this.options=r,this.elements=e,this.current=[],this.handlers={enter:[],exit:[]},this.singles={enter:[],exit:[]}}return r(t,[{key:"check",value:function(){var t=this;return this.elements.forEach(function(e){var n=t.options.test(e,t.options),r=t.current.indexOf(e),i=r>-1,o=n&&!i,u=!n&&i;o&&(t.current.push(e),t.emit("enter",e)),u&&(t.current.splice(r,1),t.emit("exit",e))}),this}},{key:"on",value:function(t,e){return this.handlers[t].push(e),this}},{key:"once",value:function(t,e){return this.singles[t].unshift(e),this}},{key:"emit",value:function(t,e){for(;this.singles[t].length;)this.singles[t].pop()(e);for(var n=this.handlers[t].length;--n>-1;)this.handlers[t][n](e);return this}}]),t}();e["default"]=function(t,e){return new i(t,e)}},function(t,e){"use strict";function n(t,e){var n=t.getBoundingClientRect(),r=n.top,i=n.right,o=n.bottom,u=n.left,f=n.width,s=n.height,c={t:o,r:window.innerWidth-u,b:window.innerHeight-r,l:i},a={x:e.threshold*f,y:e.threshold*s};return c.t>e.offset.top+a.y&&c.r>e.offset.right+a.x&&c.b>e.offset.bottom+a.y&&c.l>e.offset.left+a.x}Object.defineProperty(e,"__esModule",{value:!0}),e.inViewport=n},function(t,e){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,function(){return this}())},function(t,e,n){var r=n(5),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){function r(t,e,n){function r(e){var n=x,r=m;return x=m=void 0,E=e,w=t.apply(r,n)}function a(t){return E=t,j=setTimeout(h,e),M?r(t):w}function l(t){var n=t-O,r=t-E,i=e-n;return _?c(i,g-r):i}function d(t){var n=t-O,r=t-E;return void 0===O||n>=e||n<0||_&&r>=g}function h(){var t=o();return d(t)?p(t):void(j=setTimeout(h,l(t)))}function p(t){return j=void 0,T&&x?r(t):(x=m=void 0,w)}function v(){void 0!==j&&clearTimeout(j),E=0,x=O=m=j=void 0}function y(){return void 0===j?w:p(o())}function b(){var t=o(),n=d(t);if(x=arguments,m=this,O=t,n){if(void 0===j)return a(O);if(_)return j=setTimeout(h,e),r(O)}return void 0===j&&(j=setTimeout(h,e)),w}var x,m,g,w,j,O,E=0,M=!1,_=!1,T=!0;if("function"!=typeof t)throw new TypeError(f);return e=u(e)||0,i(n)&&(M=!!n.leading,_="maxWait"in n,g=_?s(u(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),b.cancel=v,b.flush=y,b}var i=n(1),o=n(8),u=n(10),f="Expected a function",s=Math.max,c=Math.min;t.exports=r},function(t,e,n){var r=n(6),i=function(){return r.Date.now()};t.exports=i},function(t,e,n){function r(t,e,n){var r=!0,f=!0;if("function"!=typeof t)throw new TypeError(u);return o(n)&&(r="leading"in n?!!n.leading:r,f="trailing"in n?!!n.trailing:f),i(t,e,{leading:r,maxWait:e,trailing:f})}var i=n(7),o=n(1),u="Expected a function";t.exports=r},function(t,e){function n(t){return t}t.exports=n}])});
},{}],3:[function(require,module,exports){
'use strict';

require('./bootstrap');
require('./components/Browser');
require('./components/Faq');
require('./components/AnimateIt');
require('./components/Header');
require('./components/Team');
require('./components/AnimateNumber');
require('./components/ContentPhoto');
require('./components/CallToAction');
require('./components/LogoserieFooter');
require('./components/Album');
require('./components/SmallTop');
require('./components/PngToSvg');
require('./components/Menu');
require('./components/EqualHeight');
require('./components/Anchor');
require('./components/Reservations/_reservations');

},{"./bootstrap":4,"./components/Album":5,"./components/Anchor":6,"./components/AnimateIt":7,"./components/AnimateNumber":8,"./components/Browser":9,"./components/CallToAction":10,"./components/ContentPhoto":11,"./components/EqualHeight":12,"./components/Faq":13,"./components/Header":14,"./components/LogoserieFooter":15,"./components/Menu":16,"./components/PngToSvg":17,"./components/Reservations/_reservations":21,"./components/SmallTop":22,"./components/Team":23}],4:[function(require,module,exports){
'use strict';

var _inView = require('in-view');

var _inView2 = _interopRequireDefault(_inView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$.ajaxSetup({
  data: { 'ws-is-ajax': 1 }
}); /* global ga */


$(document).ajaxSend(function (event, xhr, settings) {
  if (typeof ga !== 'undefined') {
    ga('send', 'pageview', settings.url);
  }
});

_inView2.default.threshold(0.2);

},{"in-view":2}],5:[function(require,module,exports){
'use strict';

$('.Album').adaptiveImages({
  setSrc: function setSrc(imageSrc) {
    var path = $(this).data('path').replace('%folder%', imageSrc);

    $(this).find('a').each(function () {
      var $this = $(this);

      $this.attr('href', path.replace('%filename%', $this.data('filename')));
    });
  }
});

$('.Album a').fancybox({
  padding: 0,
  margin: [0, 0, 0, 0],
  loop: true,

  arrows: true,
  closeBtn: true,
  expander: false,

  locked: false,

  caption: { type: 'over' },

  locale: $('html').attr('lang'),

  openEffect: 'fade',
  closeEffect: 'fade',
  nextEffect: 'fade',
  prevEffect: 'fade',

  helpers: { media: true }
});

},{}],6:[function(require,module,exports){
'use strict';

if (/^#[^ ]+$/.test(window.location.hash)) {
  var smallTopHeight = $('.SmallTop').outerHeight() + 15;
  var hash = window.location.hash.substr(1);

  if ($('#' + hash).length > 0 || $('[name="' + hash + '"]').length > 0) {
    (function () {
      var selector = $('#' + hash).length > 0 ? '#' + hash : '[name="' + hash + '"]';
      var anchorOffset = $(selector).offset().top - smallTopHeight;

      $(window).on('load.anchor', function () {
        window.scrollTo(0, anchorOffset);
      }).trigger('load.anchor');
    })();
  }
}

},{}],7:[function(require,module,exports){
'use strict';

var classes = ['bounce', 'flash', 'pulse', 'rubberBand', 'shake', 'headShake', 'swing', 'tada', 'wobble', 'jello', 'bounceIn', 'bounceInDown', 'bounceInLeft', 'bounceInRight', 'bounceInUp', 'bounceOut', 'bounceOutDown', 'bounceOutLeft', 'bounceOutRight', 'bounceOutUp', 'fadeIn', 'fadeInDown', 'fadeInDownBig', 'fadeInLeft', 'fadeInLeftBig', 'fadeInRight', 'fadeInRightBig', 'fadeInUp', 'fadeInUpBig', 'fadeOut', 'fadeOutDown', 'fadeOutDownBig', 'fadeOutLeft', 'fadeOutLeftBig', 'fadeOutRight', 'fadeOutRightBig', 'fadeOutUp', 'fadeOutUpBig', 'flipInX', 'flipInY', 'flipOutX', 'flipOutY', 'lightSpeedIn', 'lightSpeedOut', 'rotateIn', 'rotateInDownLeft', 'rotateInDownRight', 'rotateInUpLeft', 'rotateInUpRight', 'rotateOut', 'rotateOutDownLeft', 'rotateOutDownRight', 'rotateOutUpLeft', 'rotateOutUpRight', 'hinge', 'rollIn', 'rollOut', 'zoomIn', 'zoomInDown', 'zoomInLeft', 'zoomInRight', 'zoomInUp', 'zoomOut', 'zoomOutDown', 'zoomOutLeft', 'zoomOutRight', 'zoomOutUp', 'slideInDown', 'slideInLeft', 'slideInRight', 'slideInUp', 'slideOutDown', 'slideOutLeft', 'slideOutRight', 'slideOutUp'];

$(document).on('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', '.animated', function () {
  $(this).removeClass('animated go slow slower slowest no-mobile ' + classes.join(' '));
});

},{}],8:[function(require,module,exports){
'use strict';

var _inView = require('in-view');

var _inView2 = _interopRequireDefault(_inView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _inView2.default)('[data-animate-number-to]').on('enter', function (element) {
  var _element$getBoundingC = element.getBoundingClientRect();

  var top = _element$getBoundingC.top;


  $('[data-animate-number-to]').each(function () {
    if (!this.done && this.getBoundingClientRect().top === top) {
      this.done = true;

      $(this).prop('Counter', 0).animate({ Counter: $(this).data('animate-number-to') }, {
        duration: 2000,
        easing: 'swing',
        step: function step(now) {
          $(this).text(Math.round(now));
        }
      });
    }
  });
});

},{"in-view":2}],9:[function(require,module,exports){
'use strict';

var _bowser = require('bowser');

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var browserName = (_bowser2.default.name || 'unknown').toLowerCase().replace(' ', '-');

var browserVersion = (_bowser2.default.version || 0) + '.';
browserVersion = browserVersion.substring(0, browserVersion.indexOf('.'));

$('html').addClass(browserName);
$('html').addClass(browserName + '-' + browserVersion);

},{"bowser":1}],10:[function(require,module,exports){
'use strict';

$('.Cta-row').adaptiveImages({
  setSrc: function setSrc(imageSrc) {
    var path = $(this).data('path').replace('%folder%', imageSrc);

    $(this).css('background-image', 'url("' + path + '")');
  }
});

$(window).on('resize.cta load', function () {
  $('.Cta-row__title').css('padding-right', $('.Cta-row .btn').outerWidth() + 40);
}).trigger('resize.cta');

},{}],11:[function(require,module,exports){
'use strict';

$('.About-home__image').adaptiveImages({
  setSrc: function setSrc(imageSrc) {
    var path = $(this).data('path').replace('%folder%', imageSrc);

    $(this).css('background-image', 'url("' + path + '")');
  }
});

},{}],12:[function(require,module,exports){
'use strict';

$('.Counters-home__item').equalHeight({
  per: function per(w) {
    if (w > 700) {
      return 4;
    }

    return 2;
  }
});

},{}],13:[function(require,module,exports){
'use strict';

$('.Faq').accordion({
  unfoldIfNoHash: false,
  scrollIfNoHash: true,
  blink: true,
  anchor: 'rel',
  triggers: '.Title-h1',
  animShow: 'slideDown',
  animHide: 'slideUp',
  animSpeedShow: 300,
  animSpeedHide: 200
});

},{}],14:[function(require,module,exports){
'use strict';

var _$$owlCarousel;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var currentIndex = void 0;
var timeouts = [];

var animate = function animate(event) {
  if (event.item.index !== currentIndex) {
    currentIndex = event.item.index;

    var $element = $(event.target).find('.active');

    timeouts.forEach(function (timeout) {
      return clearTimeout(timeout);
    });
    timeouts = [];

    $('.Header-home .go').removeClass('go');

    $element.find('[data-id]').each(function () {
      var _this = this;

      var $slide = $(this);

      timeouts.push(setTimeout(function () {
        $(_this).addClass('go');
      }, 500 * ($slide.data('id') - 1)));
    });
  }
};

$('.Header-home').adaptiveImages({
  maxDpr: 1.1,
  setSrc: function setSrc(imageSrc) {
    var path = $(this).data('path').replace('%folder%', imageSrc);

    $(this).find('div[data-filename]').each(function () {
      var $this = $(this);

      $this.css('background-image', 'url("' + path.replace('%filename%', $this.data('filename')) + '")');
    });
  }
});

var items = $('.Header-home .slide').length;

$('.Header-home').owlCarousel((_$$owlCarousel = {
  items: 1,
  loop: true,
  nav: true,
  navText: ['', ''],
  dots: false,
  autoplay: true,
  autoplayTimeout: 6000,
  autoplaySpeed: 600,
  navSpeed: 600
}, _defineProperty(_$$owlCarousel, 'loop', items > 1), _defineProperty(_$$owlCarousel, 'mouseDrag', items > 1), _defineProperty(_$$owlCarousel, 'touchDrag', items > 1), _defineProperty(_$$owlCarousel, 'pullDrag', false), _defineProperty(_$$owlCarousel, 'onTranslated', function onTranslated(event) {
  return animate(event);
}), _defineProperty(_$$owlCarousel, 'onInitialized', function onInitialized(event) {
  return animate(event);
}), _$$owlCarousel));

},{}],15:[function(require,module,exports){
'use strict';

var _$$owlCarousel;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var items = $('.Logo-row .Logo-row__item').length;

$('.Logo-row .owl-carousel').owlCarousel((_$$owlCarousel = {
  nav: true,
  navText: ['', ''],
  dots: false,
  autoplay: true,
  autoplayTimeout: 6000
}, _defineProperty(_$$owlCarousel, 'autoplayTimeout', 6000), _defineProperty(_$$owlCarousel, 'autoplaySpeed', 600), _defineProperty(_$$owlCarousel, 'navSpeed', 300), _defineProperty(_$$owlCarousel, 'responsive', {
  0: {
    items: 1,
    margin: 0,
    loop: items > 1
  },
  400: {
    items: 2,
    margin: 20,
    loop: items > 2
  },
  580: {
    items: 3,
    margin: 20,
    loop: items > 3
  },
  800: {
    items: 4,
    margin: 30,
    loop: items > 4
  },
  1000: {
    items: 5,
    margin: 40,
    loop: items > 5
  },
  1200: {
    items: 6,
    margin: 40,
    loop: items > 6
  }
}), _$$owlCarousel));

},{}],16:[function(require,module,exports){
'use strict';

var lastMode = '';

var jPanelMenu = $.jPanelMenu({
  menu: '.jpanel-responsive-menu',
  trigger: '.menu-trigger',
  direction: 'right',
  animated: true,
  duration: 300,
  excludedPanelContent: 'style, script, .SmallTop',
  openPosition: '250px',

  afterOn: function afterOn() {
    var $jpanel = $('#jPanelMenu-menu');
    var excludedAttributes = ['id', 'title', 'href', 'data-type'];

    $jpanel.find('*').andSelf().each(function () {
      var isActive = $(this).is('.active');
      var attributes = $.map(this.attributes, function (item) {
        return item.name;
      });
      var $element = $(this);

      $.each(attributes, function (i, item) {
        if ($.inArray(item, excludedAttributes) === -1) {
          $element.removeAttr(item);
        }
      });

      if (isActive) {
        $element.addClass('active');
      }
    });

    // Restore the width
    $jpanel.css('width', this.openPosition);

    // Initialize the subnavigation
    $jpanel.find('li ul').hide().parent('li').find('> a').wrap('<div class="itemWrapper" />');
    $jpanel.find('li ul').parent('li').find('> div').append('<span class="jpanelTrigger" />');

    $jpanel.find('.jpanelTrigger').on('click', function (e) {
      e.preventDefault();

      $(this).toggleClass('open').closest('li').find('ul:first').slideToggle();
    });
  }
});

$(window).on('resize.jpanel-menu load', function () {
  var hasMenuClass = $('html').is('.responsive-menu');
  $('html').removeClass('responsive-menu');

  var topbarPadding = parseFloat($('.Topbar .Container').css('padding-left')) + parseFloat($('.Topbar .Container').css('padding-right'));
  var topbarLeftWidth = parseFloat($('.Topbar__left').outerWidth());
  var topbarRightWidth = parseFloat($('.Topbar__right').outerWidth());

  var mode = 'off';

  if (topbarPadding + topbarLeftWidth + topbarRightWidth > window.innerWidth - 50) {
    mode = 'on';
  }

  var topPadding = parseFloat($('.Top .Container').css('padding-left')) + parseFloat($('.Top .Container').css('padding-right'));
  var topCompanyLogoWidth = parseFloat($('.Company-logo').outerWidth());
  var topNavMainWidth = parseFloat($('.Nav-main').outerWidth());

  if (topPadding + topCompanyLogoWidth + topNavMainWidth > window.innerWidth - 50) {
    mode = 'on';
  }

  if (hasMenuClass) {
    $('html').addClass('responsive-menu');
  }

  if (mode != lastMode) {
    lastMode = mode;

    if (mode == 'on') {
      $('html').addClass('responsive-menu');
      jPanelMenu.on();
    } else {
      $('html').removeClass('responsive-menu');
      jPanelMenu.off();
    }
  }
}).trigger('resize.jpanel-menu');

},{}],17:[function(require,module,exports){
'use strict';

Modernizr.addTest('hires', function () {
    return (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI || 1) > 1;
});

if (Modernizr.svg && Modernizr.hires && !/(MSIE|Trident)/.test(window.navigator.userAgent)) {
    $.pngToSvg();
}

},{}],18:[function(require,module,exports){
'use strict';

$.datepicker.setDefaults({
  closeText: 'Sluiten',

  prevText: '←',
  nextText: '→',
  currentText: 'Vandaag',
  monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
  monthNamesShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
  dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  weekHeader: 'Wk',
  dateFormat: 'dd-mm-yy',
  firstDay: 1,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: ''
});

},{}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Helper = function () {
  function Helper() {
    _classCallCheck(this, Helper);
  }

  _createClass(Helper, null, [{
    key: 'occupiedStatus',
    value: function occupiedStatus(date, bookedDates) {
      var timestamp = (typeof date === 'undefined' ? 'undefined' : _typeof(date)) === 'object' ? date.getTime().toString() : date;

      return bookedDates[timestamp];
    }
  }, {
    key: 'datepickerColumnCount',
    value: function datepickerColumnCount() {
      var width = window.innerWidth;

      if (width <= 440) {
        return 1;
      }

      if (width <= 645) {
        return 2;
      }

      return 3;
    }
  }]);

  return Helper;
}();

exports.default = Helper;

},{}],20:[function(require,module,exports){
'use strict';

var _Helper = require('./Helper');

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var today = new Date();
today.setHours(0, 0, 0, 0);

var $target = $('input[name="dates"]');
var $pickers = $('.reservations-datepicker');
var cms = $('#content').length > 0;

var rows = $('#container').length && $pickers.is('.reservations-datepicker-disabled') > 0 ? 3 : 1;
$pickers.each(function () {
  var $picker = $(this);
  var bookedDates = $(this).data('booked-dates');

  $picker.multiDatesPicker({
    stepMonths: rows * 3,
    numberOfMonths: [rows, 3],
    maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth() + 1, 0),
    minDate: !cms ? new Date() : new Date(new Date().getFullYear() - 1, new Date().getMonth() - 1, 0),
    firstDay: 6,
    beforeShowDay: function beforeShowDay(date) {
      var occupiedStatus = _Helper2.default.occupiedStatus(date, bookedDates);

      var canClick = false;
      var className = 'status-occupied' + (occupiedStatus === 'full-processing' ? '-processing' : '');

      if (!occupiedStatus) {
        canClick = true;
        className = 'status-available';
      } else if (occupiedStatus !== 'full' && occupiedStatus !== 'full-processing') {
        canClick = !(occupiedStatus.indexOf('morning') > -1 && occupiedStatus.indexOf('evening') > -1);
        className = 'status-occupied' + (occupiedStatus.indexOf('-processing') !== -1 ? '-processing' : '') + ' status-occupied-' + occupiedStatus;
      }

      if ($picker.is('.reservations-datepicker-disabled')) {
        return [false, className];
      }

      return [canClick, className];
    }
  });
});

$pickers.on('click', function () {
  $('.ui-datepicker-inline').css('width', 'auto');
});

$pickers.each(function () {
  var _this = this;

  $(this).closest('form').on('submit', function () {
    var dates = [];

    $.each($(_this).multiDatesPicker('getDates', 'object'), function () {
      dates.push(this.getTime());
    });

    $target.val(dates.join(','));
  });
});

$('.ui-datepicker-inline').css('width', 'auto');

// Set the visible months based on the screen width
$(window).on('resize.bookings', function () {
  var datepickerColumnCount = _Helper2.default.datepickerColumnCount();

  $pickers.datepicker('option', {
    numberOfMonths: [rows, datepickerColumnCount],
    stepMonths: rows * datepickerColumnCount
  });
}).trigger('resize.bookings');

if ($target.length > 0) {
  (function () {
    var dates = [];
    var bookedDates = $pickers.data('booked-dates');

    $.each($target.val().split(','), function (index, value) {
      var timestamp = parseInt(value);

      if (timestamp > 0 && _Helper2.default.occupiedStatus(timestamp, bookedDates) !== 'full' && _Helper2.default.occupiedStatus(timestamp, bookedDates) !== 'full-processing') {
        dates.push(new Date(timestamp));
      }
    });

    if (dates.length > 0) {
      $pickers.multiDatesPicker('addDates', dates);
    }
  })();
}

},{"./Helper":19}],21:[function(require,module,exports){
'use strict';

$(function () {
  if ($(['data-booked-dates']).length > 0) {
    require('./Defaults');
    require('./Reservations');
  }
});

},{"./Defaults":18,"./Reservations":20}],22:[function(require,module,exports){
'use strict';

var shown = false;

$('.Topbar__left').contents().clone().appendTo('.SmallTop__left');
$('.Nav-main').clone().appendTo('.SmallTop__right');
$('.menu-trigger').clone().appendTo('.SmallTop__right');

$(window).on('scroll.smallTop', function () {
  var topBarHeight = $('.Topbar').outerHeight();
  var topHeight = $('.Top').outerHeight();

  var scrollTop = $(window).scrollTop();

  if (scrollTop > topBarHeight + topHeight && !shown) {
    shown = true;

    $('.SmallTop').addClass('SmallTop--show');
  } else if (scrollTop <= topBarHeight + topHeight && shown) {
    shown = false;

    $('.SmallTop').removeClass('SmallTop--show');
  }
}).trigger('scroll.smallTop');

setTimeout(function () {
  $('.SmallTop').addClass('SmallTop--transitions');
}, 1);

},{}],23:[function(require,module,exports){
'use strict';

var _inView = require('in-view');

var _inView2 = _interopRequireDefault(_inView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var items = $('.Team-home .Team__item').length;

var equalHeight = function equalHeight($items) {
  var highest = 0;

  $items.each(function () {
    var $info = $(this).find('.Team__item__info');

    $info.height('auto');

    highest = Math.max(highest, $info.height());
  }).each(function () {
    var $info = $(this).find('.Team__item__info');

    $info.height(highest);
  });
};

$('.Team-home .Team__blocks').owlCarousel({
  nav: true,
  navText: ['', ''],
  dots: false,
  onInitialized: function onInitialized() {
    (0, _inView2.default)('.Team-home .Team__blocks').once('enter', function () {
      $('.Team-home .Team__blocks [data-id]').each(function () {
        var _this = this;

        var $slide = $(this);

        setTimeout(function () {
          $(_this).addClass('go');
        }, $slide.data('id') > 4 ? 0 : 500 * ($slide.data('id') - 1));
      });
    });

    equalHeight(this.$element.find('.owl-item'));
  },
  onResized: function onResized() {
    equalHeight(this.$element.find('.owl-item'));
  },
  onTranslate: function onTranslate() {
    equalHeight(this.$element.find('.owl-item'));
  },

  responsive: {
    0: {
      items: 1,
      margin: 0,
      loop: items > 1
    },
    420: {
      items: 2,
      margin: 20,
      loop: items > 2
    },
    700: {
      items: 3,
      margin: 40,
      loop: items > 3
    },
    1000: {
      items: 4,
      margin: 50,
      loop: items > 4
    }
  }
});

},{"in-view":2}]},{},[3]);

//# sourceMappingURL=app.js.map
